import { SearchType } from 'src/graphql/generated/graphql';
import { FileTypeFile, FileTypePdf } from '@otp/icons';

export const TypeColumn = ({ type }: { type: SearchType }) => {
  let icon;

  switch (type) {
    case SearchType.Resource:
      icon = <FileTypeFile />;
      break;
    default:
      icon = <FileTypeFile />;
  }

  return (
    <div className="rounded-full bg-[var(--mui-palette-primary-200)] p-0 w-10 h-10 flex items-center justify-center">
      {icon}
    </div>
  );
};
